import { createIcon } from '@chakra-ui/react';

export const DeveloperOutlineIcon = createIcon({
  displayName: 'DeveloperOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M5.99967 15.1668H9.99967C13.333 15.1668 14.6663 13.8335 14.6663 10.5002V6.50016C14.6663 3.16683 13.333 1.8335 9.99967 1.8335H5.99967C2.66634 1.8335 1.33301 3.16683 1.33301 6.50016V10.5002C1.33301 13.8335 2.66634 15.1668 5.99967 15.1668Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.39973 6.47998L4.73973 8.13998C4.54639 8.33331 4.54639 8.65998 4.73973 8.85331L6.39973 10.5133"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.59961 6.47998L11.2596 8.13998C11.4529 8.33331 11.4529 8.65998 11.2596 8.85331L9.59961 10.5133"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
